<div class="mainRouterContainer">
        <div class="header-pnl" fxLayout="row" fxLayoutAlign="space-between">
                <div fxLayout="row" fxLayoutGap="-5px">
                    <div class="heading">
                        <p>Offline Processing</p> 
                    </div>
                    <div class="triangle"></div> 
                </div>
                <div> 
                <!-- <a>
                    <div class="dashboardIcon" fxLayout="row">
                        <img src='assets/svgs/dashboard.svg' class="dashboardIconImage">
                        <div class="dashboard">DashBoard</div>
                    </div>
                </a> -->
            </div>
            </div>

<div class="main_container">
        <div class="body_div">
        <div class="table-div">
                <div class="inner1">
                    <div class="dbHeader" fxLayout="row">
                        <div fxFlex="6%" fxLayoutAlign="start center">Admin</div>
                        <div fxFlex="10%" fxLayoutAlign="start center">Patron Id</div>
                        <div fxFlex="10%" fxLayoutAlign="start center">Item Id</div>
                        <div fxFlex="9%" fxLayoutAlign="start center">Item Type</div>
                        <div fxFlex="10%" fxLayoutAlign="start center">Operation</div>
                        <div fxFlex="15%" fxLayoutAlign="start center">Transaction Date</div>
                        <div fxFlex="18%" fxLayoutAlign="start center">Transaction time</div>
                        <div fxFlex="17%" fxLayoutAlign="start center">Status</div>
                        <!-- <div fxFlex="15%" fxLayoutAlign="start center">Remark</div> -->
                    </div>
    
                    <div class="contentHolder" fxLayout="column">
                        <div class="content" fxFlex="0 0 20%" fxLayout="row" *ngFor="let arr of txnDetails;  let i = index;">
    
                            <div fxFlex="6%" fxLayoutAlign="start center">{{arr?.admin}}</div>
                            <div fxFlex="10%" fxLayoutAlign="start center">{{arr?.patron_id}}</div>
                            <div fxFlex="10%" fxLayoutAlign="start center">{{arr?.item_identifier}}</div>
                            <div fxFlex="9%" fxLayoutAlign="start center">{{arr?.item_type}}</div>
                            <div fxFlex="10%" fxLayoutAlign="start center">{{arr?.operation}}</div>
                            <div fxFlex="15%" fxLayoutAlign="start center">{{arr?.transaction_date}}</div>
                            <div fxFlex="18%" fxLayoutAlign="start center">{{arr?.transaction_time}}</div>
                            <div fxFlex="17%" fxLayoutAlign="start center">{{arr?.status}}</div>
                            <!-- <div fxFlex="15%" fxLayoutAlign="start center">{{arr?.}}</div> -->
    
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- footer div with ls-paging -->
    <!-- <div class=table_bar>
        <ls-paging [total]="totalRecordCount" [pageSize]="recordsCount" [showRange]="false" [linkCount]="5"
            [initialPage]="1" [showFirstLast]="false" (pageChange)="pageChanged($event)"></ls-paging> 
    <div class="totalCount">
        <p class="countText">Total Count:</p> {{totalRecordCount}}
    </div>    
    </div> -->
        <div class="footer_div">
            <div class="footer_button">
                    <ls-button [value]="'Exit'" class="bottom-btn" (click)="exitClicked()"></ls-button>
            </div>
                   
            </div>
</div>
</div>